const realtimeSelector = (state) => state.realtime;
export {
  realtimeSelector
};
//# sourceMappingURL=selectors.js.map
